// extracted by mini-css-extract-plugin
module.exports = {"text":"SuccessDialog_text__1pB6e","titleText":"SuccessDialog_titleText__Te62I","content":"SuccessDialog_content__2SdSo"};